import { Circle } from '../Global/Circle';

export const PrioritiesIncidents = (props) => {
    return(
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <p style={{fontWeight: 'bold'}}>INCIDENTES POR PRIORIDADE</p>
            <div style={{display: 'flex', justifyContent: 'space-around', width: '230px'}}>
                <Circle bg='#cd0033' width='12px' height='12px' textSize='26px'>
                    {props?.data?.red ?? 0}
                </Circle>
                <Circle bg='#ffa500' width='12px' height='12px' textSize='26px'>
                    {props?.data?.orange ?? 0}
                </Circle>
                <Circle bg='#ede600' width='12px' height='12px' textSize='26px'>
                    {props?.data?.yellow ?? 0}
                </Circle>
            </div>
        </div>
    )
};